const pageTitles = {
  home: ["首页", "Home"],
  news: ["新闻公告", "News"],
  techService: ["技术服务", "Technical Services"],
  articleDetail: ["文章详情", "Article Details"],
  standard: ["标准规范", "Standards"],
  dataRemit: ["数据汇交", "Data Submission"],
  about: ["关于资源库", "About"],
  help: ["帮助", "Help"],
  dataInfo: ["数据汇交详情", "Submission Details"],
  dataInfoList: ["我的数据汇交", "My Submissions"],
  resourceResult: ["检索结果", "Search Results"],
  myIntention: ["我的意向", "My Shortlist"],
  subject: ["主题资源", "Thematic Resources"],
  subjectDetail: ["主题详情", "Theme Details"],
  articleSearch: ["文献检索", "Publication Search"],
  geneDetail: ["品系详情", "Strain Details"],
  compareDetail: ["品系对比", "Strain Comparison"],
  login: ["登录", "Log In"],
  register: ["注册", "Register"],
  userCenter: ["个人中心", "Account"],
  resourceHome: ["资源检索", "Resource Search"],
  changePwd: ["修改密码", "Change Password"],
  forgetPwd: ["找回密码", "Reset Password"],
  NotFound404: ["页面未找到", "Page Not Found"],
};

export function updateDocumentMetadata(route, locale, target = document) {
  const english = locale === "en";
  const site = english ? "National Resource Center for Mutant Mice" : "国家遗传工程小鼠资源库";
  const page = pageTitles[route && route.name];
  target.documentElement.lang = english ? "en" : "zh-CN";
  target.title = page ? `${page[english ? 1 : 0]} | ${site}` : site;
}
